const Loader = () => {
	return (
		<div id='loader'>
			<div className='box'>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
				<div></div>
			</div>
		</div>
	);
};

export default Loader;
